export default{
    isAbout(state){
        return state.isAbout;
    },
    isMobileMenu(state){
        return state.isMobileMenu;
    },
};